<template>
    <div class="flex flex-col md:flex-row gap-6">
        <div class="flex flex-col gap-6">
            <h2 class="text-2xl md:text-4xl font-semibold">Patient Overview: Initial Presentation</h2>

            <div>
                <h3 class="text-base md:text-2xl font-semibold mb-3">
                    A 32-year-old male hypertensive patient was hospitalized on January 29, 2021, in Wuhan, China
                </h3>
            </div>

            <div>
                <h3 class="text-base md:text-2xl font-semibold mb-3">Relevant medical history</h3>
                <div class="flex flex-col gap-3 font-normal">
                    <div class="p-5 text-white rounded bg-maroon">
                        Six-month history of elevated SCr
                    </div>
                    <div class="p-5 text-white rounded bg-purple">
                        Elevated SCr was accompanied by hypertension (peak of 180/100 mmHg)
                    </div>
                    <div class="p-5 text-white rounded bg-darkerblue">
                        Five-month history of maintenance hemodialysis
                    </div>
                </div>
            </div>

            <div>
                <h3 class="text-base md:text-2xl font-semibold mb-3">Family history</h3>
                <ul class="list-disc pl-4  font-light">
                    <li>
                        The patient’s mother had a history of kidney stones
                    </li>
                </ul>
            </div>
        </div>

        <img src="@/assets/img/graphics/transplant/male-body-v2.svg" alt="Male body" :style="{ maxHeight: '780px' }" />
    </div>
</template>
